const serviceArticles = [
    {
        "title": "Mobil Mogok di Jalan? Jasa Derek Mobil Terdekat Siap Bantu Anda!",
        "service_name": "Pengiriman Mobil",
        "service_desc": "Layanan derek untuk semua jenis mobil penumpang",
        "meta_description": "Mobil mogok di tengah perjalanan? Tenang, jasa derek mobil kami siap datang ke lokasi Anda dengan cepat dan aman. Hubungi layanan derek mobil terdekat sekarang juga!",
        "article_body": {
            "intro": "Apakah Anda sedang mengalami masalah mobil mogok atau kecelakaan di jalan? Tidak perlu panik! Kami hadir sebagai solusi cepat dan terpercaya untuk membantu Anda keluar dari situasi darurat di jalanan. Layanan jasa derek mobil terdekat kami siap menjangkau lokasi Anda kapan saja dan di mana saja.",
            "services": [
                {
                    "title": "Layanan Derek Gendong (Car Carrier)",
                    "description": "Kami menyediakan layanan derek gendong yang cocok untuk mobil yang tidak dapat berjalan atau rusak parah. Dengan armada khusus, mobil Anda akan diangkut dengan aman dan tanpa kerusakan tambahan."
                },
                {
                    "title": "Layanan Derek Tarik",
                    "description": "Layanan derek tarik cocok untuk kendaraan yang masih dapat digerakkan, namun perlu bantuan untuk dibawa ke bengkel atau tempat aman. Kami menggunakan peralatan terbaik untuk memastikan keselamatan kendaraan."
                },
                {
                    "title": "Bantuan Mobil Mogok Tanpa Derek",
                    "description": "Kami juga menyediakan bantuan untuk masalah ringan seperti jumper aki, pengisian bahan bakar darurat, dan ganti ban kempes, sehingga Anda dapat melanjutkan perjalanan tanpa perlu derek."
                }
            ],
            "why_choose_us": {
                "title": "Kenapa memilih kami?",
                "points": [
                    {
                        "title": "Respon cepat 24 jam",
                        "description": "Kami paham bahwa masalah di jalan bisa terjadi kapan saja, oleh karena itu kami siap melayani Anda siang dan malam."
                    },
                    {
                        "title": "Harga transparan dan terjangkau",
                        "description": "Tanpa biaya tersembunyi, semua harga diinformasikan di awal."
                    },
                    {
                        "title": "Jangkauan luas",
                        "description": "Kami melayani area Jombang, Mojokerto, Kediri, hingga Surabaya dan sekitarnya."
                    },
                    {
                        "title": "Driver profesional dan berpengalaman",
                        "description": "Kendaraan Anda akan ditangani oleh tenaga ahli yang sudah terbiasa dengan berbagai situasi."
                    }
                ]
            },
            "cta": {
                "text": "Jangan biarkan mobil mogok mengganggu aktivitas Anda. Segera hubungi jasa derek mobil terpercaya kami dan dapatkan bantuan hanya dalam hitungan menit!",
                "button_text": "Hubungi Kami via WhatsApp",
                "link": "https://wa.me/628228349889"
            }
        }
    },
    {
        "title": "Pengiriman Motor Profesional - Layanan Pengangkutan Motor dengan Peralatan Khusus",
        "service_name": "Pengiriman Motor",
        "service_desc": "Pengangkutan motor dengan peralatan khusus",
        "meta_description": "Butuh bantuan untuk mengangkut motor Anda? Layanan pengiriman motor kami menggunakan peralatan khusus untuk memastikan motor Anda diangkut dengan aman, cepat, dan tepat waktu.",
        "article_body": {
            "intro": "Apakah Anda mengalami kendala dalam mengangkut motor karena jarak atau keterbatasan kendaraan? Layanan Pengiriman Motor kami hadir untuk membantu Anda. Dirancang khusus untuk pengangkutan motor, kami menggunakan peralatan modern dan teknik khusus guna menjaga keamanan motor Anda selama perjalanan. Dengan dedikasi tinggi dan pengalaman bertahun-tahun, tim kami siap memberikan layanan pengiriman motor yang profesional, aman, dan tepat waktu, sehingga Anda dapat kembali fokus pada aktivitas penting Anda.",
            "services": [
                {
                    "title": "Pengangkutan Motor dengan Peralatan Modern",
                    "description": "Kami mengutamakan keamanan motor Anda dengan menggunakan peralatan khusus yang telah teruji dan dirancang untuk mengangkut motor dengan berbagai ukuran dan jenis."
                },
                {
                    "title": "Layanan Terjadwal dan Responsif",
                    "description": "Tim kami siap mengoordinasikan jadwal pengangkutan motor sesuai kebutuhan Anda, memastikan bahwa motor Anda diantar dengan tepat waktu."
                },
                {
                    "title": "Proteksi Selama Perjalanan",
                    "description": "Setiap motor yang kami angkut akan dilindungi dengan sistem pengamanan khusus untuk meminimalisir potensi kerusakan selama transportasi."
                }
            ],
            "why_choose_us": {
                "title": "Mengapa Memilih Layanan Pengiriman Motor Kami?",
                "points": [
                    {
                        "title": "Keamanan Terjamin",
                        "description": "Peralatan khusus dan prosedur keselamatan ketat membuat setiap pengiriman motor berjalan dengan aman."
                    },
                    {
                        "title": "Layanan Cepat dan Tepat Waktu",
                        "description": "Respon cepat dan jadwal yang dapat diandalkan adalah prioritas kami untuk memastikan motor Anda tiba sesuai janji."
                    },
                    {
                        "title": "Harga Transparan dan Kompetitif",
                        "description": "Kami menawarkan layanan berkualitas tinggi dengan harga yang jujur tanpa biaya tersembunyi."
                    }
                ]
            },
            "cta": {
                "text": "Jangan biarkan kendala pengangkutan motor menghambat aktivitas Anda. Hubungi kami sekarang untuk layanan pengiriman motor profesional yang mengutamakan keamanan dan kecepatan!",
                "button_text": "Pesan Pengiriman Motor",
                "link": "https://wa.me/6282288349889"
            }
        }
    },
    {
        "title": "Layanan Beban Berat - Derek untuk Truk dan Kendaraan Berat",
        "service_name": "Beban Berat",
        "service_desc": "Derek untuk truk dan kendaraan berat",
        "meta_description": "Beban kendaraan berat seperti truk memerlukan penanganan khusus. Layanan beban berat kami siap mengatasi masalah dengan peralatan canggih dan teknisi ahli untuk derek kendaraan berat Anda.",
        "article_body": {
            "intro": "Kendaraan berat seperti truk dan alat berat memerlukan penanganan yang berbeda dibandingkan kendaraan penumpang. Layanan Beban Berat kami dirancang khusus untuk mendukung kebutuhan derek truk dan kendaraan berat. Menggunakan peralatan canggih serta teknik pengangkutan yang teruji, tim kami memberikan solusi darurat yang cepat dan aman untuk setiap situasi. Baik untuk evakuasi truk mogok di jalan tol atau pengangkutan alat berat ke lokasi proyek, kami menjamin layanan yang profesional, efisien, dan selalu mengutamakan keselamatan.",
            "services": [
                {
                    "title": "Derek untuk Truk dan Alat Berat",
                    "description": "Dilengkapi dengan peralatan khusus, kami siap mengangkut truk, trailer, dan kendaraan berat lainnya tanpa mengorbankan integritas kendaraan."
                },
                {
                    "title": "Teknologi Pengangkutan Mutakhir",
                    "description": "Menggunakan teknologi terkini, setiap pengangkutan kendaraan berat diatur dengan presisi untuk memastikan proses yang mulus dan aman."
                },
                {
                    "title": "Tim Teknisi Profesional",
                    "description": "Profesional berpengalaman kami selalu siap untuk menangani situasi darurat, memberikan dukungan penuh dalam setiap pemindahan kendaraan berat."
                }
            ],
            "why_choose_us": {
                "title": "Alasan Memilih Layanan Beban Berat Kami",
                "points": [
                    {
                        "title": "Keandalan dan Keamanan",
                        "description": "Prosedur keselamatan dan peralatan khusus memastikan kendaraan berat Anda ditangani dengan penuh kehati-hatian."
                    },
                    {
                        "title": "Respon Cepat 24 Jam",
                        "description": "Masalah kendaraan berat tidak mengenal waktu, dan begitu pula layanan kami. Kami siap membantu kapan saja."
                    },
                    {
                        "title": "Pendekatan Profesional",
                        "description": "Tim ahli kami dilengkapi dengan pelatihan terbaik untuk menangani berbagai tantangan dalam pengangkutan kendaraan berat."
                    }
                ]
            },
            "cta": {
                "text": "Butuh layanan derek untuk kendaraan berat? Hubungi kami segera untuk mendapatkan penanganan profesional dan solusi yang dapat diandalkan dalam setiap situasi darurat kendaraan berat.",
                "button_text": "Hubungi Layanan Beban Berat",
                "link": "https://wa.me/6282288349889"
            }
        }
    },
    {
        "title": "Layanan Darurat 24/7 - Bantuan Cepat di Setiap Keadaan Darurat",
        "service_name": "Layanan Darurat",
        "service_desc": "Bantuan 24/7 untuk keadaan darurat",
        "meta_description": "Dalam keadaan darurat di jalan, tidak ada waktu untuk menunggu. Layanan darurat 24/7 kami siap membantu Anda dengan solusi cepat dan efektif untuk setiap masalah kendaraan.",
        "article_body": {
            "intro": "Dalam situasi darurat, setiap detik berarti. Layanan Darurat 24/7 kami didedikasikan untuk memberikan bantuan cepat saat Anda menghadapi masalah kendaraan. Dengan respons instan dan dukungan teknisi profesional, kami siap menghadapi berbagai kondisi darurat—mulai dari kecelakaan ringan hingga kejadian tak terduga yang mengakibatkan kendaraan mogok. Layanan kami memastikan bahwa bantuan tepat waktu selalu ada, mengembalikan rasa aman dan ketenangan dalam menghadapi tantangan di jalan.",
            "services": [
                {
                    "title": "Respon Darurat Cepat",
                    "description": "Layanan kami beroperasi 24 jam penuh, dengan tim yang selalu siap merespons setiap panggilan darurat seketika."
                },
                {
                    "title": "Bantuan Lengkap di Tempat",
                    "description": "Dari evakuasi kendaraan hingga bantuan teknis darurat, setiap dukungan kami diberikan langsung di lokasi Anda."
                },
                {
                    "title": "Konsultasi Keselamatan Berkendara",
                    "description": "Kami juga memberikan informasi dan tips berguna untuk meminimalisir risiko di jalan, sehingga Anda merasa lebih siap menghadapi situasi darurat."
                }
            ],
            "why_choose_us": {
                "title": "Mengapa Memilih Layanan Darurat Kami?",
                "points": [
                    {
                        "title": "Operasional 24/7",
                        "description": "Masalah kendaraan tidak mengenal waktu, dan begitu pula layanan kami. Kami selalu siap sedia tanpa henti."
                    },
                    {
                        "title": "Profesional dan Handal",
                        "description": "Teknisi ahli kami selalu berpengalaman dalam menangani berbagai insiden darurat, memastikan penanganan yang tepat dan cepat."
                    },
                    {
                        "title": "Solusi Komprehensif",
                        "description": "Tidak hanya evakuasi, kami menyediakan berbagai solusi darurat lainnya yang dapat mengatasi setiap permasalahan dengan efektif."
                    }
                ]
            },
            "cta": {
                "text": "Jika Anda menghadapi keadaan darurat di jalan, jangan tunda untuk mendapatkan bantuan. Hubungi layanan darurat kami sekarang juga dan rasakan kecepatan respon serta profesionalisme kami dalam membantu setiap situasi kritis.",
                "button_text": "Hubungi Layanan Darurat",
                "link": "https://wa.me/6282288349889"
            }
        }
    },
    {
        "title": "Cepat Sampai Tujuan - Layanan Towing yang Mengutamakan Kecepatan dan Keamanan",
        "service_name": "Cepat Sampai Tujuan",
        "service_desc": "Sampai dengan cepat dan aman",
        "meta_description": "Ingin kendaraan Anda sampai dengan cepat dan aman? Layanan towing kami memastikan transportasi kendaraan dengan kecepatan tinggi dan standar keselamatan terbaik.",
        "article_body": {
            "intro": "Setiap perjalanan membutuhkan ketepatan waktu, terutama ketika Anda bergantung pada layanan towing. Layanan Cepat Sampai Tujuan kami didesain khusus untuk memastikan bahwa kendaraan Anda diangkut dengan kecepatan tinggi tanpa mengurangi standar keselamatan. Kami memahami bahwa kecepatan dan keamanan adalah kunci untuk mengatasi kendala transportasi, sehingga tim profesional kami dilengkapi dengan peralatan modern untuk menangani setiap situasi dengan cepat dan efisien. Dengan pendekatan yang terintegrasi dan koordinasi yang sangat baik, kami memastikan kendaraan Anda tiba di tujuan dengan aman dan tepat waktu.",
            "services": [
                {
                    "title": "Respon Cepat dan Efisien",
                    "description": "Layanan kami selalu siap 24 jam, sehingga setiap permintaan bantuan ditanggapi dengan kecepatan maksimal."
                },
                {
                    "title": "Transportasi Aman",
                    "description": "Setiap kendaraan diangkut dengan prosedur keselamatan yang ketat, memastikan integritas dan keamanan selama perjalanan."
                },
                {
                    "title": "Koordinasi Profesional",
                    "description": "Kami mengoptimalkan jadwal dan rute pengangkutan untuk meminimalkan waktu tempuh dan memastikan kendaraan Anda sampai sesuai janji."
                }
            ],
            "why_choose_us": {
                "title": "Mengapa Layanan Cepat Sampai Tujuan Kami Unggul?",
                "points": [
                    {
                        "title": "Kecepatan Tanggapan",
                        "description": "Sistem operasional kami memastikan bahwa setiap panggilan bantuan segera direspon, memberikan Anda ketenangan saat dibutuhkan."
                    },
                    {
                        "title": "Keamanan Prioritas Utama",
                        "description": "Metode pengangkutan kami mengutamakan keselamatan, sehingga kendaraan Anda selalu dalam pengawasan teknisi profesional."
                    },
                    {
                        "title": "Optimasi Rute",
                        "description": "Kami merencanakan rute terbaik yang memungkinkan pengiriman kendaraan dengan waktu tempuh yang singkat tanpa mengorbankan keselamatan."
                    }
                ]
            },
            "cta": {
                "text": "Tidak ada waktu untuk menunggu ketika kecepatan dan keamanan adalah yang utama. Hubungi kami sekarang dan nikmati layanan towing yang memastikan kendaraan Anda tiba dengan cepat dan aman di tujuan!",
                "button_text": "Pesan Layanan Cepat Sampai Tujuan",
                "link": "https://wa.me/6282288349889"
            }
        }
    },
    {
        "title": "Towing Jarak Jauh - Layanan Derek Antar Kota dan Provinsi yang Handal",
        "service_name": "Towing Jarak Jauh",
        "service_desc": "Layanan derek antar kota dan provinsi",
        "meta_description": "Layanan towing jarak jauh kami siap mengangkut kendaraan Anda antar kota atau provinsi dengan kecepatan dan keamanan terjamin. Hubungi kami untuk solusi transportasi kendaraan jarak jauh yang profesional.",
        "article_body": {
            "intro": "Mengangkut kendaraan dalam jarak jauh membutuhkan perencanaan dan keahlian khusus agar setiap perjalanan berlangsung lancar. Layanan Towing Jarak Jauh kami menawarkan solusi derek antar kota dan provinsi yang menggabungkan kecepatan, efisiensi, dan keamanan. Dengan armada modern dan tim teknisi yang berpengalaman, kami memastikan setiap pengangkutan dilakukan dengan perencanaan yang cermat, memastikan kendaraan Anda tiba dengan selamat dan tepat waktu di tujuan. Kami memahami betapa pentingnya keandalan dalam pengiriman kendaraan, terutama untuk perjalanan jarak jauh yang penuh tantangan.",
            "services": [
                {
                    "title": "Pengangkutan Antar Kota dan Provinsi",
                    "description": "Layanan kami mencakup rute-rute strategis antar kota dan provinsi, dengan sistem pelacakan dan koordinasi yang memastikan keakuratan waktu pengiriman."
                },
                {
                    "title": "Armada Towing Modern",
                    "description": "Menggunakan peralatan dan kendaraan towing terkini, kami mengoptimalkan setiap perjalanan sehingga kendaraan Anda diangkut dengan aman dan efisien."
                },
                {
                    "title": "Pendekatan Terintegrasi",
                    "description": "Kami bekerja sama dengan berbagai pihak untuk memastikan setiap detail perjalanan, mulai dari persiapan awal hingga pengantaran, berjalan lancar."
                }
            ],
            "why_choose_us": {
                "title": "Alasan Memilih Layanan Towing Jarak Jauh Kami",
                "points": [
                    {
                        "title": "Jangkauan Luas",
                        "description": "Kami melayani pengangkutan kendaraan untuk berbagai rute antar kota dan provinsi dengan jaringan yang luas."
                    },
                    {
                        "title": "Profesionalisme Tinggi",
                        "description": "Dengan pengalaman bertahun-tahun, tim kami menangani setiap perjalanan dengan keahlian dan profesionalisme yang tinggi."
                    },
                    {
                        "title": "Keamanan dan Kepastian",
                        "description": "Setiap pengiriman kendaraan direncanakan dengan teliti dan dilaksanakan dengan standar keamanan yang ketat untuk melindungi kendaraan Anda."
                    }
                ]
            },
            "cta": {
                "text": "Untuk solusi transportasi kendaraan dalam jarak jauh, keandalan dan keamanan adalah kunci. Hubungi kami sekarang untuk mendapatkan layanan towing jarak jauh yang profesional dan dapat diandalkan.",
                "button_text": "Pesan Towing Jarak Jauh",
                "link": "https://wa.me/6282288349889"
            }
        }
    }
]

export default serviceArticles;